import { ReactElement } from "react";
import Head from "next/head";

import Form from "@/components/contact/Form";
import Header from "@/components/contact/Header";
import { MainLayout, SubLayout } from "@/containers/layout/LandingLayout";

import SemiCircleGroupBottom from "@/public/contact/semi-circle-group-orange.svg";
import SemiCircleGroupBottomDesktop from "@/public/contact/semi-circle-group-orange-desktop.svg";
import SemiCircleGroupTop from "@/public/contact/semi-circle-group.svg";
import SemiCircleGroupTopDesktop from "@/public/contact/semi-circle-group-desktop.svg";

const Contact = () => {
  return (
    <>
      <Head>
        <title>Contact Keyzy Homes About Rent To Buy Homeownership</title>
        <link rel="canonical" href="https://www.keyzy.com/contact" />
        <meta
          name="description" key="description"
          content="Contact Keyzy for any questions about our rent to buy solution. Our team is ready to assist with any questions. Send us an email or chat to us on WhatsApp."
        />
        <meta
          name="twitter:card"
          content="Contact Keyzy for any questions about our rent to buy solution. Our team is ready to assist with any questions. Send us an email or chat to us on WhatsApp."
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/" key="ogurl" />
        <meta property="og:image" content="/landing/keyzy-meta-image.png" key="ogimage" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta
          property="og:title"
          content="Contact Keyzy Homes About Rent To Buy Homeownership"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Contact Keyzy for any questions about our rent to buy solution. Our team is ready to assist with any questions. Send us an email or chat to us on WhatsApp."
          key="ogdesc"
        />
      </Head>

      <SubLayout allowOverflow>
        <div className="relative flex flex-col pb-24 overflow-visible xl:px-10 mt-11 xl:mt-40 xl:items-start xl:flex-row xl:pb-32">
          <Header />
          <Form className="flex-grow xl:ml-16 mt-11" />

          <SemiCircleGroupTop className="absolute -top-5 w-full max-w-[26.25rem] -left-12 md:hidden" />
          <SemiCircleGroupTopDesktop className="absolute right-0 hidden xl:-top-24 xl:-left-12 md:inline-block md:left-auto md:right-14 md:top-10" />
          <SemiCircleGroupBottom className="absolute bottom-0 -left-10 md:right-10 md:left-auto xl:hidden w-full max-w-[23.75rem]" />
          <SemiCircleGroupBottomDesktop className="absolute hidden bottom-4 -left-20 xl:inline-block max-w-[26.25rem]" />
        </div>
      </SubLayout>
    </>
  );
};

Contact.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout theme="light">{page}</MainLayout>;
};

export default Contact;
